export function trackWhatsAppClick() {
  const fbq = (window as any).fbq
  if (typeof fbq === 'function') {
    fbq('trackCustom', 'WhatsAppClick', {
      content_name: 'AZ Landing',
      destination: 'WhatsApp',
    })
    fbq('track', 'Lead', {
      content_name: 'AZ Landing Lead',
      value: 300,
      currency: 'USD',
    })
  }
}
